import { ISharePositionState } from "./interfaces";

export const INITIAL_SHARE_POSITION_STATE: ISharePositionState = {
	subscriptions: [],
	invitations: [],
	activeSubscription: "",
	hoverSubscription: "",
	activeTab: "subscriptions",
};
